export const BrandTheme = {
  Changeable: "changeable",
  Static: "static",
};
